import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { Voucher } from '../../../control-panel.service'
import { ConciergeCancelVoucherService } from './cancel-voucher.service'
import { ConciergeModalSucessComponent } from '../../../modal-sucess/modal-success.component'
import { HttpErrorResponse } from '@angular/common/http'
import { GenericErrorComponent } from '../../../../../simple-bottom-sheets/generic-error.component'

interface FormattedVoucher extends Voucher {
	clientName: string
}

@Component({
	standalone: true,
	selector: 'feature-pm-concierge-cancel-voucher-content',
	templateUrl: './cancel-voucher.component.html',
	styleUrls: ['./cancel-voucher.component.scss'],
	imports: [CommonModule, MatIconModule, MatButtonModule],
})
export class ConciergeCancelVoucherComponent {
	private bottomSheet = inject(MatBottomSheet)
	private dialogRef = inject(MatDialogRef<ConciergeCancelVoucherComponent>)
	public voucher = inject<FormattedVoucher>(MAT_DIALOG_DATA)
	private dialog = inject(MatDialog)
	private cancelVoucherService = inject(ConciergeCancelVoucherService)

	closeModal() {
		this.dialogRef.close()
	}

	cancelVoucher() {
		this.cancelVoucherService
			.update(this.voucher._id!, {
				status: 'canceled',
			})
			.subscribe({
				next: () => {
					this.dialog.open(ConciergeModalSucessComponent, { data: 'Voucher cancelado!' })
					this.dialogRef.close('updated')
				},
				error: (err: HttpErrorResponse) => {
					const errorMessage = err.error?.message || 'Erro desconhecido'
					this.bottomSheet.open(GenericErrorComponent, {
						data: {
							error: errorMessage,
							title: 'Erro ao adicionar benefício',
							btnMessage: 'Fechar',
						},
					})
				},
			})
	}
}
